import React from "react";


import img from "../contents/dev/Backpicture.png"
import noise from "../contents/dev/noise.png";
import GoldenTides from "../contents/dev/GoldenTides_sliced_card.png";
import Polystrike from "../contents/dev/Polystrike_sliced_card.png";
import Necromantic from "../contents/dev/Necromantic_slice_card.png";
//import { useNavigate } from "react-router-dom";

export default function OurGames() {
    //const navigate = useNavigate();
    // const redirectOnClick = async (event) => {
    //     event.preventDefault()
    //     try{
    //         navigate("/web");
    //     }catch(e){
    //         console.log(e)
    //     }
    // }
    return (
        <div className="flex-grow bg-black w-full">
            <div className=" overflow-visible">
                <div className="w-full bg-cover bg-center"
                     style={{backgroundImage: `linear-gradient(to left, rgba(255, 255, 255, 0.0), rgba(0, 0, 0, 1)), url(${img})`}}
                    // style={{backgroundImage: `url(${img})`}}
                >
                    <div className="content flex sm:justify-center align-end sm:align-start sm:py-48 pt-24 pb-6 text-white lg:px-0 px-6">
                        <div className="sm:space-y-10 space-y-0">
                            <div className="sm:text-5xl text-3xl font-bold">
                                <div>
                                    Check our most relevant
                                    <br class="" />
                                    <span className="text-yellow-400">
                                        {" Projects"}
                                    </span>
                                </div>

                            </div>
                            <div className="text-3xl font-light sm:block hidden">
                                We believe in human connection and more than finalizing a project,
                                <br class="hidden sm:inline" />
                                we want to add value to all the deliveries.
                                Teamwork and
                                <br class="hidden sm:inline" />
                                ownership over client projects, allow us to offer comprehensive
                                <br class="hidden sm:inline" />
                                and non-standard solutions for your needs!
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sm:hidden block text-white px-6 mt-6">
                    <div className="text-2xl font-light text-left">
                        <div>
                            We believe in human connection and more than finalizing a project,
                            <br class="hidden sm:inline" />
                            we want to add value to all the deliveries.
                            Teamwork and
                            <br class="hidden sm:inline" />
                            ownership over client projects, allow us to offer comprehensive
                            <br class="hidden sm:inline" />
                            and non-standard solutions for your needs!

                        </div>

                    </div>
                </div>
                
                <div className="gap-y-10 md:gap-x-10 lg:px-8 sm:space-y-10 md:space-y-0 my-24 cards-content">
                    <div className="flex justify-center">
                        <div className="card-size flex flex-wrap">
                            <div className="card-picture-size relative">
                                <img className="" src={GoldenTides} alt=''/>
                                <a target="_blank" rel="noopener noreferrer" href = "https://www.goldentides.gg/" style={{top: "50px"}} className="cursor-pointer card-redirect-badge absolute flex items-center justify-center bg-gray-1 h-20 w-20 rounded-full border-2 border-amber-400 ">
                                    <svg className="stroke-current" width="26" height="46" viewBox="0 0 27 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 3L23 23L3 43"  stroke-width="5" stroke-linecap="round"/>
                                    </svg>
                                </a>
                            </div>
                            <div style={{ backgroundImage: `url(${noise})` }}
                                 className="text-white font-sans card-description-part-size space-y-4 bg-gray-1">
                                <div className="font-bold border-gray-2 border-b-2 pb-2 w-1/2">
                                    Golden Tides
                                </div>
                                <div className="font-light">
                                    Golden Tides - is a fast-paced PvP Adventure MOBA set in a pirate-themed world. Teams of four race to hunt for treasure in 25-30 minute matches.
                                    Engage in skill-based combat across dynamic terrains, and thrilling ship battles, and experience a unique adventure.
                                </div>
                                <div className="font-light">
                                    Our dev and art team are the masterminds behind exciting gameplay and a stable custom-built backend that has already been integrated into Epic and will soon be available on Steam platforms.
                                    The official release is coming this summer!
                                </div>
                            </div>
                        </div>
                        <div className="hidden 2xl:block card-part bg-gray-1 -ml-4" style={{backgroundImage: `url(${noise})`}}/>
                    </div>

                    <div className="flex justify-center">
                        <div className="card-size flex flex-wrap">
                            <div className="card-picture-size relative">
                                <img className="object-cover" src={Polystrike} alt=''/>
                                <a target="_blank" rel="noopener noreferrer" href = "https://www.goldentides.gg/" style={{top: "50px"}} className="cursor-pointer card-redirect-badge absolute  flex items-center justify-center bg-gray-1 h-20 w-20 rounded-full border-2 border-amber-400 ">
                                    <svg className="stroke-current" width="26" height="46" viewBox="0 0 27 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 3L23 23L3 43"  stroke-width="5" stroke-linecap="round"/>
                                    </svg>
                                </a>
                            </div>
                            <div style={{ backgroundImage: `url(${noise})` }}
                                 className="text-white font-sans card-description-part-size space-y-4 bg-gray-1">
                                <div className="font-bold border-gray-2 border-b-2 pb-2 w-1/2">
                                    Polystrike
                                </div>
                                <div className="font-light">
                                    Polystrike is designed to appeal to a broad spectrum of players blending top-down shooting mechanics with fast-paced skill-based combat and strategic team play.
                                </div>
                                <div className="font-light">
                                    The game is available for early testing on Steam. Our dev and art team are progressing fast with the development of this banger.
                                </div>
                            </div>
                        </div>
                        <div className="hidden 2xl:block card-part bg-gray-1 -ml-4" style={{backgroundImage: `url(${noise})`}}/>
                    </div>

                    <div className="flex justify-center">
                        <div className="card-size flex flex-wrap">
                            <div className="card-picture-size relative">
                                <img className="object-cover" src={Necromantic} alt=''/>
                                <a target="_blank" rel="noopener noreferrer" href = "https://www.goldentides.gg/" style={{top: "50px"}} className="cursor-pointer card-redirect-badge absolute  flex items-center justify-center bg-gray-1 h-20 w-20 rounded-full border-2 border-amber-400 ">
                                    <svg className="stroke-current" width="26" height="46" viewBox="0 0 27 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 3L23 23L3 43"  stroke-width="5" stroke-linecap="round"/>
                                    </svg>
                                </a>
                            </div>
                            <div style={{ backgroundImage: `url(${noise})` }}
                                 className="text-white font-sans card-description-part-size space-y-4 bg-gray-1">
                                <div className="font-bold border-gray-2 border-b-2 pb-2 w-1/2">
                                    Necromantic
                                </div>
                                <div className="font-light">
                                    Our lead level designer helped build this already-released fantasy game.
                                    Study up to survive in this dark and dangerous fantasy Bullet Heaven. Solo or by online co-op.
                                </div>
                                <div className="font-light">
                                    Gaining infamy and surviving hordes of enemies with all your limbs intact will take studying,
                                    going to class, and completing assignments to upgrade and master your skills.
                                </div>
                            </div>
                        </div>
                        <div className="hidden 2xl:block card-part bg-gray-1 -ml-4" style={{backgroundImage: `url(${noise})`}}/>
                    </div>
                </div>
                
                

                <div className="content gap-16 py-20 hidden">
                    
                    {/*<div className="card-size flex flex-wrap justify-center items-center">*/}
                    {/*    <div className="relative">*/}
                    {/*        <div>*/}
                    {/*            <img className="card-picture-size" src={GoldenTides} alt=''/>*/}
                    {/*        </div>*/}
                    {/*        <div>*/}
                    {/*            <a target="_blank" rel="noopener noreferrer" href = "https://www.goldentides.gg/" style={{top: "30px"}} className="cursor-pointer card-redirect-badge absolute  flex items-center justify-center bg-gray-1 h-20 w-20 rounded-full border-2 border-amber-400 ">*/}
                    {/*                <svg className="stroke-current" width="26" height="46" viewBox="0 0 27 46" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
                    {/*                    <path d="M3 3L23 23L3 43"  stroke-width="5" stroke-linecap="round"/>*/}
                    {/*                </svg>*/}
                    {/*            </a>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div className="text-white card-description-part-size p-4 space-y-6 bg-gray-1" style={{backgroundImage: `url(${noise})`}}>*/}
                    {/*        <div className="w-1/2 text-xl font-medium border-gray-2 border-b-2">*/}
                    {/*            Golden Tides*/}
                    {/*        </div>*/}
                    {/*        <div className="">*/}
                    {/*            Golden Tides - is a fast-paced PvP Adventure MOBA set in a pirate-themed world. Teams of four race to hunt for treasure in 25-30 minute matches.*/}
                    {/*            Engage in skill-based combat across dynamic terrains, and thrilling ship battles, and experience a unique adventure.*/}
                    {/*        </div>*/}
                    {/*        <div>*/}
                    {/*            Our dev and art team are the masterminds behind exciting gameplay and a stable custom-built backend that has already been integrated into Epic and will soon be available on Steam platforms.*/}
                    {/*            The official release is coming this summer!*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    
                    
                    
                    
                    
                    <div className="sm:mx-0 mx-6 relative flex flex-wrap justify-center" >
                        <div className="relative">
                            <div className="h-full card sm:-mr-4 bg-gray-1  text-white " style={{backgroundImage: `url(${noise})`}}>
                                <div style={{backgroundImage: `url(${noise})`}} className="relative bg-gray-1 h-50 card" >
                                    <img className="object-cover" src={GoldenTides} alt=''/>
                                </div>
                                <a target="_blank" rel="noopener noreferrer" href = "https://www.goldentides.gg/" style={{top: "30px"}} className="cursor-pointer card-redirect-badge absolute  flex items-center justify-center bg-gray-1 h-20 w-20 rounded-full border-2 border-amber-400 ">
                                    <svg className="stroke-current" width="26" height="46" viewBox="0 0 27 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 3L23 23L3 43"  stroke-width="5" stroke-linecap="round"/>
                                    </svg>
                                </a>
                            </div>
                        </div>
                        <div style={{backgroundImage: `url(${noise})`}} className="bg-gray-1 card-body sm:pl-20 sm:w-1/2 w-full">
                            <div className="bg-gray-1 text-white  sm:px-0 sm:pr-9 px-8 sm:pb-8 pb-4 " style={{backgroundImage: `url(${noise})`}}>
                                <div  className="relative sm:w-2/3 w-full sm:pr-8 pb-2 text-xl font-medium border-gray-2 border-b-2 my-4">
                                    Golden Tides
                                </div>
                                <div className="font-light">
                                    Golden Tides - is a fast-paced PvP Adventure MOBA set in a pirate-themed world. Teams of four race to hunt for treasure in 25-30 minute matches.
                                    Engage in skill-based combat across dynamic terrains, and thrilling ship battles, and experience a unique adventure.
                                </div>
                                <div className="font-light sm:pt-8 pt-4">
                                    Our dev and art team are the masterminds behind exciting gameplay and a stable custom-built backend that has already been integrated into Epic and will soon be available on Steam platforms.
                                    The official release is coming this summer!
                                </div>
                            </div>
                        </div>
                        <div className="card-part bg-gray-1 -ml-4" style={{backgroundImage: `url(${noise})`}}/>
                    </div>


                    <div className="sm:mx-0 mx-6 relative flex flex-wrap justify-center">
                        <div className="relative">
                            <div className="h-full card sm:-mr-4 bg-gray-1  text-white " style={{backgroundImage: `url(${noise})`}}>
                                <div style={{backgroundImage: `url(${noise})`}} className="relative bg-gray-1 h-50 card" >
                                    <img className="object-cover" src={Polystrike} alt=''/>
                                </div>
                                <a target="_blank" rel="noopener noreferrer" href = "https://steamcommunity.com/sharedfiles/filedetails/?id=2053031118" style={{top: "30px"}} className="cursor-pointer card-redirect-badge absolute  flex items-center justify-center bg-gray-1 h-20 w-20 rounded-full border-2 border-amber-400 ">
                                    <svg className="stroke-current" width="26" height="46" viewBox="0 0 27 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 3L23 23L3 43"  stroke-width="5" stroke-linecap="round"/>
                                    </svg>
                                </a>
                            </div>
                        </div>

                        <div style={{backgroundImage: `url(${noise})`}} className="bg-gray-1 card-body sm:pl-20 sm:w-1/2 w-full">
                            <div className="bg-gray-1 text-white  sm:px-0 sm:pr-9 px-8 sm:pb-8 pb-4 " style={{backgroundImage: `url(${noise})`}}>
                                <div  className="relative sm:w-2/3 w-full sm:pr-8 pb-2 text-xl font-medium border-gray-2 border-b-2 my-4">
                                    Polystrike
                                </div>
                                <div className="font-light">
                                    Polystrike is designed to appeal to a broad spectrum of players blending top-down shooting mechanics with fast-paced skill-based combat and strategic team play.
                                    The game is available for early testing on Steam. Our dev and art team are progressing fast with the development of this banger.
                                </div>
                            </div>
                        </div>
                        <div className="card-part bg-gray-1 -ml-4" style={{backgroundImage: `url(${noise})`}}/>
                    </div>

                    <div className="sm:mx-0 mx-6 relative flex flex-wrap justify-center">
                        <div className="relative">
                            <div className="h-full card sm:-mr-4 bg-gray-1  text-white " style={{backgroundImage: `url(${noise})`}}>
                                <div style={{backgroundImage: `url(${noise})`}} className="relative bg-gray-1 h-50 card" >
                                    <img className="object-cover" src={Necromantic} alt=''/>
                                </div>
                                <a target="_blank" rel="noopener noreferrer" href = "https://store.steampowered.com/app/2615010/Necromantic/?" className="cursor-pointer card-redirect-badge absolute  flex items-center justify-center bg-gray-1 h-20 w-20 rounded-full border-2 border-amber-400 ">
                                    <svg className="stroke-current" width="26" height="46" viewBox="0 0 27 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 3L23 23L3 43"  stroke-width="5" stroke-linecap="round"/>
                                    </svg>
                                </a>
                            </div>
                        </div>

                        <div className="bg-gray-1 card-body sm:pl-20 sm:w-1/2 w-full" style={{backgroundImage: `url(${noise})`}}>
                            <div className="bg-gray-1 text-white  sm:px-0 sm:pr-9 px-8 sm:pb-8 pb-4 " style={{backgroundImage: `url(${noise})`}}>
                                <div className="relative sm:w-2/3 w-full sm:pr-8 pb-2 text-xl font-medium border-gray-2 border-b-2 my-4">
                                    Necromantic
                                </div>
                                <div className="font-light">
                                    Necromantic - Our lead level designer helped build this already-released dark and dangerous fantasy Bullet Heaven.
                                    You can check it out on Steam and play solo or through an online co-op.
                                </div>
                            </div>
                        </div>


                        <div className="card-part bg-gray-1 -ml-4" style={{backgroundImage: `url(${noise})`}}/>

                    </div>
                </div>
            </div> 
        </div>
    );
}